import styled from '@emotion/styled';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import worldMap from '../../images/1-homepage/map-light-blue.webp';
import { BreadCrumbs } from './Bread-Crumbs';

export const AltHeroStyled = styled.section`
    margin-top: 140px;
    color: ${({ theme }) => theme.colors.gray5};
    .large-container {
        display: flex;
        flex-direction: column-reverse;
    }
    ul {
        margin-bottom: 16px;
    }
    h1 {
        margin-bottom: 42px;
    }
    @media ${({ theme }) => theme.device.laptop} {
        background: linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)),
            url(${worldMap});
        background-size: contain;
        height: 400px;
        background-repeat: no-repeat;
        background-position: center;
        margin-bottom: 60px;
        h1 {
            font-size: 40px;
            line-height: 54px;
            margin-bottom: 64px;
        }
        .large-container {
            display: flex;
            gap: 64px;
            justify-content: center;
            align-items: center;
            flex-direction: row;
        }
        .image {
            width: 600px;
            height: 600px;
        }
    }
`;

export const AltHero: React.FC<{
    title: string;
    slug: string;
    featured_image: {
        name: string;
        childImageSharp: { gatsbyImageData: IGatsbyImageData };
    };
}> = props => {
    const { title, slug } = props;

    const links = [
        { path: '/office-news/', name: 'Blog' },
        { path: `${slug}`, name: `${title}` },
    ];

    return (
        <AltHeroStyled>
            <div className="large-container">
                <div>
                    <BreadCrumbs blog links={links} />
                    <h1>{title}</h1>
                </div>
            </div>
        </AltHeroStyled>
    );
};
